import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search-form"
export default class extends Controller {
  static targets = ["input", "item", "category", "count", "empty"]

  connect() {
    this.filter()
  }

  filter() {
    if (!this.hasItemTarget) return

    const query = this.hasInputTarget ? this.inputTarget.value.trim().toLowerCase() : ""
    let visibleItemsCount = 0

    this.categoryTargets.forEach((category) => {
      const rows = this.itemTargets.filter((item) => category.contains(item))
      const categoryMatches = query !== "" && (category.dataset.searchText || "").includes(query)
      let visibleCategoryItemsCount = 0

      rows.forEach((item) => {
        const itemMatches = (item.dataset.searchText || "").includes(query)
        const matches = query === "" || categoryMatches || itemMatches
        item.classList.toggle("hidden", !matches)
        if (matches) visibleCategoryItemsCount += 1
      })

      category.classList.toggle("hidden", visibleCategoryItemsCount === 0)
      const count = this.countTargets.find((target) => category.contains(target))
      if (count) count.textContent = visibleCategoryItemsCount
      visibleItemsCount += visibleCategoryItemsCount
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visibleItemsCount > 0)
    }
  }

  reset() {
    if (this.hasInputTarget) this.inputTarget.value = ""
    this.filter()
  }
}
